import { ReactComponent as EvcIcon } from '../../../../images/roam-logo-w-tag-white.svg'

const BrandingHeader = () => {

  return (
        <div
      style={{
        width: '100%',
        height: '70px',
        backgroundColor: '#fc5d5d',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '8px',
        marginBottom: '32px',
      }}
    >
      <EvcIcon style={{ height: '48px', width: 'auto' }}/>
    </div>
  );
};

export default BrandingHeader;